'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const TradingHostContext = createContext(null);
export function TradingHostProvider({
  value,
  children
}) {
  return _jsx(TradingHostContext.Provider, {
    value: value,
    children: children
  });
}
export function useTradingHostContext() {
  const ctx = useContext(TradingHostContext);
  if (ctx === null) {
    throw new Error("[backend-sdk-v2] useTradingHostContext: missing <TradingHostProvider>. Wrap the app in <TradingHostProvider value={\u2026}> before calling any SDK trading hook.");
  }
  return ctx;
}